/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_To_LockInputs */

const en_queue_sos_to_lock = /** @type {(inputs: Queue_Sos_To_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders to lock`)
};

/**
* | output |
* | --- |
* | "Sales orders to lock" |
*
* @param {Queue_Sos_To_LockInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_to_lock = /** @type {((inputs?: Queue_Sos_To_LockInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_To_LockInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_to_lock(inputs)
});